import { render, staticRenderFns } from "./Boletos.vue?vue&type=template&id=48a9a0c8&scoped=true&"
import script from "./Boletos.vue?vue&type=script&lang=js&"
export * from "./Boletos.vue?vue&type=script&lang=js&"
import style0 from "./Boletos.vue?vue&type=style&index=0&id=48a9a0c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a9a0c8",
  null
  
)

export default component.exports